import { createStore } from 'vuex'
import { common } from '@/store/common/common';

export default createStore({
    modules: {
        common,
    }
})
